import React from 'react';
import { withTranslation } from '../../i18n';
import styles from './index.scss';

import BackToProfile from '../BackToProfile';

function TrophiesUnsupported({ displayName, username }) {
  return (
    <main className={styles.contentBackground}>
      <h1 className={styles.title}>
        <span role="img" aria-label="Face with no mouth">
          😶
        </span>{' '}
        {displayName} has no trophies!
      </h1>
      <p>Trophies are exclusive awards for BuzzFeed members.</p>
      <div className={styles.backButtonWrapper}>
        <BackToProfile username={username} />
      </div>
    </main>
  );
}

export default withTranslation('common')(TrophiesUnsupported);
